<template>
<div>
  <div class="text-center mt-4"><img src="/images/supalytic-icon.svg" width="50"></div>
    <div class="homepage_heading mt-2 pt-4 pb-4 px-3">Frequently Asked Questions</div>

<div v-if="loading" class="text-center py-2"><i class="fas fa-spinner fa-spin"></i></div>
<div v-else-if="items.length == 0" class="text-center py-2">No data</div>

<div v-else class="accordion pb-4 pt-4" id="accordionExample">

<div v-for="(item, index) in items" :key="index.id" class="accordion-item">
    <h2 class="accordion-header" :id="`heading_${item.id}`">
      <button
        class="accordion-button collapsed"
        type="button"
        data-mdb-toggle="collapse"
        :data-mdb-target="`#collapse_${item.id}`"
        aria-expanded="false"
        :aria-controls="`collapse_${item.id}`">{{ item.question }}</button>
    </h2>
    <div :id="`collapse_${item.id}`" class="accordion-collapse collapse" :aria-labelledby="`heading_${item.id}`">
      <div class="accordion-body" v-html="item.answer"></div>
    </div>
  </div>
</div>
</div>
</template>

<script>
export default {

  data() {
    return {
      loading: true,
      items: [],
    };
  },

  created() {
    this.getData();
  },

  methods: {

    getData() {

      axios.get('/get/questions').
      then((response) => {
        this.items = response.data;
        this.loading = false;
      });

    },
  },
};
</script>